import React, { Suspense } from 'react';
import PropTypes from '../../helpers/propTypes';
import Loading from '../Loading/Loading';

function LazyLoading({ children }) {
  return <Suspense fallback={<Loading dark />}>{children}</Suspense>;
}

LazyLoading.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LazyLoading;
